import { render, staticRenderFns } from "./DetailsMsg.vue?vue&type=template&id=0b386d40&scoped=true&lang=pug&"
import script from "./DetailsMsg.vue?vue&type=script&lang=js&"
export * from "./DetailsMsg.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMsg.vue?vue&type=style&index=0&id=0b386d40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b386d40",
  null
  
)

export default component.exports